import { render, staticRenderFns } from "./SettingUser.vue?vue&type=template&id=1333199a"
import script from "./SettingUser.vue?vue&type=script&lang=ts"
export * from "./SettingUser.vue?vue&type=script&lang=ts"
import style0 from "./SettingUser.vue?vue&type=style&index=0&id=1333199a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports